import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	expand: {
		id: 'business-list.list-view.group-item.expand-icon.expand',
		defaultMessage: 'Expand',
		description: 'Tooltip text to expand items',
	},
	collapse: {
		id: 'business-list.list-view.group-item.expand-icon.collapse',
		defaultMessage: 'Collapse',
		description: 'Tooltip text to collapse items',
	},
	collapseLabel: {
		id: 'business-list.list-view.group-item.expand-icon.collapse-label',
		defaultMessage: 'collapse',
		description: 'Collapse icon label',
	},
	open: {
		id: 'business-list.list-view.group-item.expand-icon.open',
		defaultMessage: 'open',
		description: 'Open icon label',
	},
});
